// import wappage from "@/components/_WAP/IndexPage";
import pcpage from "@/components/Homepage";
import { loadPage } from "@/components/_WAP/js/base";

loadPage(pcpage);
